import { Component, OnInit } from '@angular/core';
import { LocalstorageService } from 'src/app/global/localstorage.service';
import { Router } from '@angular/router';
import { LoginDialog } from '../header/header.component';
import { MatDialog } from '@angular/material';
import { first } from 'rxjs/operators';
import { NavbarService } from './navbar.service';
import { UpdatefontsizeService } from '../../../services/updatefontsize.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  public isLogin: any;
  urlName: string;
  public About: string;
  KDMCProfileLan: string;
  ObjectivesLan: string;
  TransportCommitteeLan: string;
  NmpmlTeamLan: string;
  OrgStructureLan: string;
  ItInitiativeLan: string;
  FuturePlansLan: string;
  public CitizenCorner: string;
  public HelpDeskLan: string;
  public RitLan: string;
  public FAQLan: string;
  public CareerLan: string;
  public OnlineServices: string;
  ScrollinfoLan: string;
  PassLan: string;
  SmartCardLan: string;
  public MediaCorner: string;
  PressReleaseLan: string;
  WhatsNewLan: string;
  AdvertzLan: string;
  PhotoGalleryLan: string;
  public language: any;
  ContactUsLan: string;
  passlan: string;
  BusServices: string;
  FareConcessionsLan: string;
  RegularBusesLan: string;
  RailwayStationServicesLan: string;
  BusNetworkLan: string;
  PassesLan: string;
  RouteLan: string;
  RouteMap: string;
  TimeTable: string;
  Fare: string;
  VisionLan: string;
  MissionStatementLan: string;
  OurPartnersLan: string;
  GrievancesLan: string;
  TimeTableLan: string;
  FeedbackLan: string;
  TicketBookLan:string;
  classToggled = true;
  MarqueD: any;
  fontSize = 14;
  NASize = this.fontSize;
  UserId: string;
  constructor(public router: Router,public dialog: MatDialog, private MarqueService :NavbarService, private updateFont : UpdatefontsizeService) { }

  ngOnInit() {
    this.isLogin = LocalstorageService.getLanguage('Token');
    this.language = LocalstorageService.getLanguage('language');
    if(this.language == 'en') {
      this.About = "ABOUT US";
      this.KDMCProfileLan = 'KDMT PROFILE';
      //this.ObjectivesLan = 'OBJECTIVES';
      this.VisionLan ='VISION AND MISSION';
      this.MissionStatementLan = 'MISSION STATEMENT';
      // this.ScrollinfoLan = 'KDMC - Kalyan Dombivli Development Corporation Ltd.';
      this.OurPartnersLan ='OUR PARTNERS';
      this.TransportCommitteeLan = 'TRANSPORT COMMITTEE';
      this.NmpmlTeamLan = 'CITILINC TEAM';
      this.OrgStructureLan = 'ORGANIZATION STRUCTURE';
      this.ItInitiativeLan = 'ITMS INITIATIVE';
      this.FuturePlansLan = 'FUTURE PLANS';
      this.CitizenCorner = "CITIZEN CORNER";
      this.RitLan = "RTI";
      this.HelpDeskLan = "HELPDESK";
      this.FAQLan = "FAQs";
      this.CareerLan = "CAREER";
      this.PassLan = "PASS";
      this.SmartCardLan = "SMART CARD";
      this.MediaCorner = "MEDIA CORNER";
      this.PressReleaseLan = "PRESS RELEASE";
      this.WhatsNewLan = "WHAT'S NEW";
      this.AdvertzLan = "ADVERTISEMENT";
      this.PhotoGalleryLan = "PHOTO GALLERY";
      this.ContactUsLan = "CONTACT US";
      this.BusServices = "BUS SERVICES";
      this.FareConcessionsLan = "FARE CONCESSIONS";
      this.RegularBusesLan = "REGULAR BUSES";
      this.RailwayStationServicesLan = "RAILWAY STATION AND AIRPORT SERVICES";
      this.BusNetworkLan = "BUS NETWORK";
      this.PassesLan = "PASSES";
      this.GrievancesLan = "GRIEVANCES";
      this.FeedbackLan = "FEEDBACK/SUGGESTIONS";
      this.OnlineServices = "ONLINE SERVICES";
      this.passlan = "PASS";
      this.TimeTableLan = "TIME TABLE";
      this.TicketBookLan = "TICKET BOOKING";

    } else if (this.language == 'mr') {
      this.About = "आमच्या विषयी";
      this.GrievancesLan = "तक्रारी";
      this.FeedbackLan = "अभिप्राय/सूचना";
      this.KDMCProfileLan = 'प्रस्तावना';
      //this.ObjectivesLan = 'उद्दीष्टे';
      this.VisionLan ='ध्येय आणि उद्दिष्ठे';
      this.MissionStatementLan = 'मिशन विधान';
      // this.ScrollinfoLan = 'सिटिलिंक - नाशिक शहर बस सेवा';
      this.OurPartnersLan ='आमचे सहकारी';
      this.TransportCommitteeLan = 'परिवहन समिती';
      this.NmpmlTeamLan = 'सिटीलिंक कार्यसंघ';
      this.OrgStructureLan = 'कंपनी संरचना';
      this.ItInitiativeLan = 'माहिती व तंत्रज्ञान';
      this.FuturePlansLan = 'भविष्यातील योजना';
      this.CitizenCorner = "सिटीझन कॉर्नर";
      this.RitLan = "माहितीचा अधिकार";
      this.FAQLan = "माझे प्रश्न व शंका";
      this.CareerLan = "नोकरी विषयक";
      this.HelpDeskLan = "मदत कक्ष";
      this.OnlineServices = "ऑनलाईन सेवा";
      this.PassLan = "माहिती";
      this.SmartCardLan = "स्मार्ट कार्ड";
      this.MediaCorner = "माध्यम विभाग";
      this.PressReleaseLan = "प्रकाशित बातमी";
      this.WhatsNewLan = "नवीन विशेष";
      this.AdvertzLan = "जाहिरात";
      this.PhotoGalleryLan = "फोटो गॅलरी";
      this.passlan = "पास";
      this.ContactUsLan = "आमच्याशी संपर्क साधा";
      this.BusServices = "बस सेवा";
      this.FareConcessionsLan = "तिकिटांवर सवलती";
      this.RegularBusesLan = "नियमित बसेस";
      this.RailwayStationServicesLan = "रेल्वे स्टेशन व विमानतळ सेवा";
      this.BusNetworkLan = "बस नेटवर्क";
      this.PassesLan = "पास माहिती";
      this.TimeTableLan = "वेळापत्रक";
      this.TicketBookLan = "तिकीट बुकिंग";
    }

    this.updateFont.currentFontSource$.subscribe((type) => {
        if(type == '+'){
          if (this.fontSize < (this.NASize + 3)) {
            this.fontSize++;
          }
        } else if(type == '-'){
          if (this.fontSize > (this.NASize - 3)) {
            this.fontSize--;
          }
        } else{
            this.fontSize = this.NASize;
        }
    });

    this.UserId = LocalstorageService.getLocal('user');
    this.GetMarqueData();
  }

  public toggleField() {
    this.classToggled = !this.classToggled;
  }

  onClickRedirect(URLName) {
    if(URLName == 'Contactus' || URLName == 'TimeTable' || URLName=='PlanJourney') {
      this.router.navigate(['/' + URLName]);
    } else {
      LocalstorageService.setLocal('geturl',URLName);   // Set Clicked URL into LocalStorageService
      if(this.isLogin != null){
        this.router.navigate(['/' + URLName]);
      } else {
        //this.router.navigate(['/Login']);
        const dialogRef = this.dialog.open(LoginDialog);

        dialogRef.afterClosed().subscribe(result => {
          //console.log(`Dialog result: ${result}`);
        });
      }
    }
  }

  GetMarqueData(){
    this.MarqueService.GetMarque().pipe(first()).subscribe(result =>{
      this.MarqueD = JSON.parse(result.data);

        this.ScrollinfoLan = this.MarqueD[0].announcemessage;

    });
  }

  BackHome() {

    LocalstorageService.setLocal('URLKey',0);
    LocalstorageService.setLocal('ShowGIS', 0);

    window.location.replace('/');



  }

  RedirectToProfile(id){
    this.urlName = "Nmpmlprofile";
    this.router.navigate(['/' + this.urlName.split('?')[0]], { queryParams: { divid: id }});
  }

  divert(id){
    this.urlName = "MyGrievances";
    this.router.navigate(['/' + this.urlName.split('?')[0]], { queryParams: { num: id }});
  }
  goTo(id){
    this.urlName = "Citizencorner";
    this.router.navigate(['/' + this.urlName.split('?')[0]], { queryParams: { page: id }});
  }
  goOn(id){
    this.urlName = "Busservices";
    this.router.navigate(['/' + this.urlName.split('?')[0]], { queryParams: { page: id }});
  }
  moveTo(id) {
    this.urlName = "Mediacorner";
    this.router.navigate(['/' + this.urlName.split('?')[0]], { queryParams: { divert: id } });
  }
}
